import { Button, Card, Select, Space, Table } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react";
import { ItemAPI, InventoryAPI } from "@/apis/material";
import { ItemInfoLink } from "@/components/ItemInfoLink";
import { Number } from "@/components/Numeric";
import { ItemType } from "@/enums/material";
import { FileUtil } from "@/utils";

const InventoryByLot = () => {
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [data, setData] = useState([]);

    const getData = useCallback(async (selectedItems) => {
        setData(await InventoryAPI.itemInventories(selectedItems));
    }, []);

    useEffect(() => {
        const fetchItems = async () => {
            const value = await ItemAPI.actives();
            setItems(value.filter((item) => item.itemType === ItemType.Inventory));
        };
        fetchItems();
    }, []);

    useEffect(() => {
        getData();
    }, [getData]);

    return (
        <Card title="Inventory by Lot#" extra={<Space>
            <Select placeholder="Item Name"
                showSearch
                allowClear
                mode="multiple"
                filterOption={(inputValue, option) =>
                    option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                }
                maxTagCount={1}
                style={{ width: 200 }}
                value={selectedItems}
                options={items.map((item) => ({
                    label: item.itemName,
                    value: item.id,
                }))}
                onChange={(val) => setSelectedItems(val)}></Select>
            <Button type="primary" onClick={() => {
                getData(selectedItems);
            }}>Search</Button>
            <Button type="primary" onClick={async () => {
                const res = await InventoryAPI.exportItemInventory({ itemIds: selectedItems });
                FileUtil.download(res.data, "Inventory_By_Lot.xlsx");
            }}>Export</Button>
        </Space>}>
            <Table columns={[
                {
                    title: 'Item Name',
                    dataIndex: 'itemName',
                    render: (text, record) => <ItemInfoLink value={record.itemId}>{record.itemName}</ItemInfoLink>,
                }, {
                    title: 'Warehouse',
                    dataIndex: 'warehouseName',
                }, {
                    title: 'Location',
                    dataIndex: 'locationName',
                }, {
                    title: 'Lot#',
                    dataIndex: 'lot',
                }, {
                    title: 'Date Received',
                    dataIndex: 'dateReceived',
                }, {
                    title: "Qty Onhand",
                    dataIndex: 'onHandQty',
                    render: (text, record) => <Number value={record.onHandQty} />,
                }, {
                    title: "Committed Qty",
                    dataIndex: 'pickedQty',
                    render: (text, record) => <Number value={record.pickedQty} />,
                }, {
                    title: "Available Qty",
                    dataIndex: 'availableQty',
                    render: (text, record) => <Number value={record.availableQty} />,
                }
            ]}
                rowKey="id"
                scroll={{ y: 'calc(100vh - 280px)' }}
                data={data}
            />
        </Card>
    );
};

export { InventoryByLot };